import { Component, Input, ViewEncapsulation } from '@angular/core';

import { PieceProductSettings } from 'extensions/core/piece-product/front/models/piece-product.models';
import { ImageDetails } from 'extensions/core/piece-product/front/piece-product-render.component';
import { Product } from 'idt-ecommerce-api/catalog/products/products.models';
import { IdtComponent } from 'shared/models/idt-components/idt-component.models';


@Component({
  selector: 'render-product-sizes-modal',
  templateUrl: 'render-product-sizes-modal.component.html',
  styleUrls: ['./render-product-sizes-modal.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class RenderProductSizesModalComponent {

  @Input() public props!: {
    data: {
      product: Product;
      imageDetails: ImageDetails | undefined;
      piece: IdtComponent<PieceProductSettings> | undefined;
      country?: string;
      lang?: string;
    };
  };

}
